import { render } from "./LegacyReportEditor.vue?vue&type=template&id=6adb5705&scoped=true"
import script from "./LegacyReportEditor.vue?vue&type=script&lang=js"
export * from "./LegacyReportEditor.vue?vue&type=script&lang=js"

import "./LegacyReportEditor.vue?vue&type=style&index=0&id=6adb5705&scoped=true&lang=css"

import exportComponent from "/Volumes/Whisper/Development/projects/sid/ui/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6adb5705"]])

export default __exports__
import QInput from 'quasar/src/components/input/QInput.js';
import QToggle from 'quasar/src/components/toggle/QToggle.js';
import qInstall from "../../../../../../../../../Volumes/Whisper/Development/projects/sid/ui/node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QInput,QToggle});
